import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-courses', imports: [
    RouterOutlet
  ], templateUrl: './courses.component.html', styleUrl: './courses.component.scss'
})
export class CoursesComponent {

}
